import {
  XCircle,
  Loader2,
  CalendarClock,
  ArrowRight,
} from "@/components/icons";
import BusySlotsPanel from "./BusySlotsPanel";
import { conflictsWith } from "./dateUtils";

export default function RescheduleForm({
  appointment,
  busySlots,
  busyLoading,
  newDate,
  setNewDate,
  minDateTime,
  rescheduleErr,
  acting,
  onSubmit,
  onCancel,
}) {
  const inlineConflict =
    newDate && conflictsWith(newDate, appointment.duration_min, busySlots);

  return (
    <div className="mt-7" data-testid="reschedule-form">
      <p className="text-center text-sm text-black/70 mb-3">
        Selecciona una nueva fecha y hora para tu cita:
      </p>

      <BusySlotsPanel
        busy={busySlots}
        loading={busyLoading}
        selectedDate={newDate}
        duration={appointment.duration_min}
        onPick={(iso) => setNewDate(iso)}
      />

      <div className="bg-white rounded-2xl p-4 space-y-3">
        <label className="text-[10px] font-bold uppercase tracking-widest text-black/45 block">
          Nueva fecha y hora
        </label>
        <input
          data-testid="reschedule-datetime-input"
          type="datetime-local"
          value={newDate}
          onChange={(e) => setNewDate(e.target.value)}
          min={minDateTime}
          className="w-full bg-[#F5F5F5] border border-[#E5E7EB] rounded-2xl px-4 py-3 text-black focus:outline-none focus:border-black/60"
        />
        {inlineConflict ? (
          <p
            data-testid="reschedule-inline-conflict"
            className="text-xs text-red-700 bg-red-50 border border-red-100 rounded-xl px-3 py-2 flex items-start gap-2"
          >
            <XCircle className="w-3.5 h-3.5 mt-0.5 shrink-0" />
            <span>
              Ese horario choca con otra cita del doctor. Elige otro horario.
            </span>
          </p>
        ) : null}
        {rescheduleErr ? (
          <p className="text-sm text-red-700" data-testid="reschedule-error">
            {rescheduleErr}
          </p>
        ) : null}
        <div className="flex flex-col sm:flex-row gap-2 pt-1">
          <button
            type="button"
            data-testid="reschedule-submit-btn"
            onClick={onSubmit}
            disabled={acting || !newDate}
            className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#01BC8E] hover:bg-[#01BC8E] disabled:opacity-60 text-white font-bold text-sm transition"
          >
            {acting ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <CalendarClock className="w-4 h-4" />
            )}
            Confirmar nueva fecha
            {!acting ? <ArrowRight className="w-4 h-4" /> : null}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center px-5 py-3 rounded-xl bg-white text-black font-bold text-sm border border-[#E5E7EB] hover:bg-black/[0.04] transition"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
